import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';

import { fromCreateJob, jobFormIdSelect } from './job-form.actions';

export interface JobFormState {
  jobFormId: number;
  fromCreateJob: string;
}

export const initialState: JobFormState = {
  jobFormId: 0,
  fromCreateJob: '',
};

export const jobFormReducer = createReducer(
  initialState,
  on(jobFormIdSelect, (state, { id }) => ({
    ...state,
    jobFormId: id,
  })),
  on(fromCreateJob, (state, { fromCreateJob }) => ({
    ...state,
    fromCreateJob,
  })),
);

export const getJobFormState = createFeatureSelector<JobFormState>('jobForm');

export const getJobFormId = createSelector(
  getJobFormState,
  (state: JobFormState) => state.jobFormId,
);

export const getFromCreateJob = createSelector(
  getJobFormState,
  (state: JobFormState) => state.fromCreateJob,
);
